const LEDGER = [
  { time: '2025-05-28 14:32', desc: '充值到账', amount: '+¥10.00', balance: '¥560.00' },
  { time: '2025-05-28 10:15', desc: '充值到账', amount: '+¥550.00', balance: '¥550.00' },
  { time: '2025-05-27 18:40', desc: 'API 调用扣费', amount: '-¥0.50', balance: '¥0.00' },
];

const Wallet = () => (
  <>
    <p className="console-panel-desc">查看钱包余额变动明细与台账记录。</p>
    <div className="console-stats">
      <div className="console-stat-card">
        <div className="console-stat-label">当前余额</div>
        <div className="console-stat-value highlight">¥560.000000</div>
      </div>
      <div className="console-stat-card">
        <div className="console-stat-label">冻结金额</div>
        <div className="console-stat-value">¥0.000000</div>
      </div>
    </div>
    <div className="console-card">
      <div className="console-card-header">
        <h3 className="console-card-title">流水明细</h3>
      </div>
      <div className="console-card-body console-table-wrap">
        <table className="console-table">
          <thead>
            <tr>
              <th>时间</th>
              <th>说明</th>
              <th>金额</th>
              <th>余额</th>
            </tr>
          </thead>
          <tbody>
            {LEDGER.map((row) => (
              <tr key={row.time + row.desc}>
                <td>{row.time}</td>
                <td>{row.desc}</td>
                <td style={{ color: row.amount.startsWith('+') ? 'var(--accent)' : undefined }}>
                  {row.amount}
                </td>
                <td>{row.balance}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </>
);

export default Wallet;
